const getDeviceImage = (deviceType: any) => {
  if (deviceType && deviceType.image) {
    return `${deviceType.image}?cb=${(new Date()).valueOf()}`;
  } else {
    return deviceType && deviceType.slug ? `${process.env.VUE_APP_RESOURCES_BUCKET}/devices/logos/${deviceType.slug}.png?cb=${(new Date()).valueOf()}` : '/img/default-device.png';
  }
};

const getBearerLogo = (bearer: string) => {
  switch (bearer.toLowerCase()) {
    case 'sigfox':
      return require('@/assets/images/network-logos/sigfox.png');
    case 'lora':
      return require('@/assets/images/network-logos/lora_wan.png');
    default:
      return require('@/assets/images/daizy-logo-icon.png');
  }
};
const getLANProtocolLogo = (lanProtocol: string) => {
  switch (lanProtocol.toLowerCase()) {
    case 'mbus':
      return require('@/assets/images/lan-protocol/mbus.png');
    case 'modbus':
      return require('@/assets/images/lan-protocol/modbus.png');
  }
};

const getOrgImage = (organisation: any) => `${process.env.VUE_APP_RESOURCES_BUCKET}/organisations/logos/${organisation.slug}.png?cb=${(new Date()).valueOf()}`;

export {
  getDeviceImage,
  getOrgImage,
  getBearerLogo,
  getLANProtocolLogo,
};
